const projects = [
  {
    id: 1,
    title: "Luxury Apartment – Mumbai",
    status: "Completed"
  },
  {
    id: 2,
    title: "Villa Interior – Pune",
    status: "Completed"
  }
];

export default function Projects() {
  return (
    <>
      <h1>Our Projects</h1>

      {projects.map(p => (
        <div key={p.id} style={{ marginBottom: "16px" }}>
          <h3>{p.title}</h3>
          <p>Status: {p.status}</p>
        </div>
      ))}
    </>
  );
}
